import React from 'react';
import Header from '@/components/Header';
import MinimalFooter from '@/components/MinimalFooter';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { 
  Heart,
  ArrowRight,
  Sparkles,
  Brain
} from 'lucide-react';
import { Link } from 'react-router-dom';

const Favorites = () => {
  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Header />
      
      <div className="container mx-auto px-4 py-6 flex-grow">
        <section className="mb-8">
          <div className="flex items-center justify-between mb-4">
            <h2 className="text-2xl font-bold tracking-tight">Favorites</h2>
            <Link to="/" className="text-sm font-medium text-primary hover:underline">
              Explore More <ArrowRight className="inline-block ml-1 h-4 w-4" />
            </Link>
          </div>
          
          <div className="relative">
            <div className="absolute inset-0 bg-background/80 backdrop-blur-sm z-10 rounded-2xl flex items-start justify-center pt-12">
              <div className="text-center space-y-2">
                <Sparkles className="h-8 w-8 text-primary mx-auto" />
                <p className="text-lg font-medium">Coming Soon</p>
                <p className="text-sm text-muted-foreground max-w-[200px]">
                  Save and organize your favorite binaural beats sessions
                </p>
              </div>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {[1, 2, 3].map((_, index) => (
                <Card key={index} className="bg-card/50 border-primary/10">
                  <CardHeader>
                    <CardTitle className="flex items-center gap-2">
                      <Heart className="mr-2 h-4 w-4" />
                      Favorite Session
                    </CardTitle>
                    <CardDescription>
                      Coming soon
                    </CardDescription>
                  </CardHeader>
                  <CardContent>
                    <p className="text-sm text-muted-foreground">
                      Save and organize your favorite binaural beats sessions
                    </p>
                  </CardContent>
                </Card>
              ))}
            </div>
          </div>
        </section>
      </div>
      
      <MinimalFooter />
    </div>
  );
};

export default Favorites;
